function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import get from 'lodash/get';
import { FormattedMessage } from 'react-intl';
import Modal from 'components/Modal';
import Button from 'components/Form/Button';
import accessTokenShape from 'shapes/accessTokenShape';
import App from 'modules/App';
import CloudDrive from 'modules/CloudDrive';
import * as actions from '../../../actions';
import * as constants from '../../../constants';
import * as selectors from '../../../selectors';
import messages from '../../../messages';
import styles from './GdprExportModal.pcss';
var _React_PureComponent;
/* eslint-disable react/prop-types */ class GdprExportModal extends (_React_PureComponent = React.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        const { patientProfile, isFetchAccountDumpInProgress, isFetchDumpInProgress, hasFetchAccountDumpErrors, hasFetchPhiSetErrors, hasFetchDumpErrors } = props;
        const hasErrors = hasFetchAccountDumpErrors || hasFetchPhiSetErrors || hasFetchDumpErrors;
        if (hasErrors) {
            return {
                isInProgress: false,
                isFetchDumpInProgress: false
            };
        }
        if (isFetchDumpInProgress !== state.isFetchDumpInProgress && patientProfile) {
            if (isFetchDumpInProgress) {
                return {
                    isFetchDumpInProgress: true
                };
            }
            return {
                isInProgress: false,
                isFetchDumpInProgress: false,
                isDataCollected: true
            };
        }
        if (isFetchAccountDumpInProgress !== state.isInProgress && !isFetchAccountDumpInProgress && !patientProfile) {
            return {
                isInProgress: false,
                isDataCollected: true
            };
        }
        return null;
    }
    componentDidUpdate(prevProps) {
        if (!this.isOpen || !this.props.patientProfile) {
            return;
        }
        const { openModalId, patientProfile, gdprData } = this.props;
        const accessToken = get(patientProfile, 'accessToken');
        if (prevProps.openModalId !== openModalId && !accessToken) {
            this.props.onConnect(patientProfile);
            return;
        }
        const prevPhiSet = get(prevProps.gdprData, 'phiSet');
        const phiSet = get(gdprData, 'phiSet');
        if (prevPhiSet !== phiSet && phiSet) {
            this.props.onFetchCentralStorageDump(gdprData.phiSet, patientProfile);
        }
    }
    onCollectData() {
        this.setState({
            isInProgress: true
        });
        this.props.onGdprFetchAccountDump();
        if (this.props.patientProfile) {
            this.props.onFetchPhiSet(this.props.patientProfile);
        }
    }
    onSaveToFile() {
        this.props.onGdprSaveToFile();
        this.setState({
            isDataSaved: true
        });
    }
    async onClose() {
        this.props.onCancelFetchCentralStorageDump();
        await this.props.onCloseModal();
        this.props.onGdprClearData();
        this.setState({
            isInProgress: false,
            isFetchDumpInProgress: false,
            isDataCollected: false,
            isDataSaved: false
        });
    }
    onButtonAction() {
        const { isDataCollected, isDataSaved } = this.state;
        if (isDataSaved) return this.onClose();
        if (isDataCollected) return this.onSaveToFile();
        return this.onCollectData();
    }
    get isOpen() {
        return this.props.openModalId === constants.GDPR_EXPORT_MODAL;
    }
    get modalHeaderMessage() {
        return messages.headers.exportData;
    }
    get buttonMessage() {
        const { isDataCollected, isDataSaved } = this.state;
        if (isDataSaved) return messages.buttons.close;
        if (isDataCollected) return messages.buttons.save;
        return messages.buttons.collectData;
    }
    renderCancelButton(isDataSaved) {
        if (isDataSaved) {
            return null;
        }
        return /*#__PURE__*/ _jsx("div", {
            className: "col-6",
            children: /*#__PURE__*/ _jsx(Button, {
                styleModifier: "quaternary",
                labelMessage: messages.buttons.cancel,
                className: "btn--block mb-0",
                onClick: ()=>this.onClose()
            })
        });
    }
    renderActions() {
        const { isInProgress, isDataSaved } = this.state;
        if (isInProgress) {
            return /*#__PURE__*/ _jsx("p", {
                className: "text--center pt-5",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.waitingForDataCollected))
            });
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: "row w-100",
            children: [
                this.renderCancelButton(isDataSaved),
                /*#__PURE__*/ _jsx("div", {
                    className: `col-${isDataSaved ? 12 : 6}`,
                    children: /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "primary",
                        labelMessage: this.buttonMessage,
                        className: "btn--block btn--filled mb-0",
                        onClick: ()=>this.onButtonAction()
                    })
                })
            ]
        });
    }
    renderInnerContent() {
        const { isInProgress, isDataCollected, isDataSaved } = this.state;
        if (isInProgress) {
            return /*#__PURE__*/ _jsx("div", {
                className: "text--center",
                children: /*#__PURE__*/ _jsx("img", {
                    src: "/assets/svg/loader.svg",
                    className: "rotatingLoader",
                    alt: ""
                })
            });
        }
        if (isDataSaved) return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.dataSaved));
        if (isDataCollected) return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.dataCollected));
        return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.collectData));
    }
    renderModalContent() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.content,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.innerContent,
                    children: this.renderInnerContent()
                }),
                this.renderActions()
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsx(Modal, {
            modalId: constants.GDPR_EXPORT_MODAL,
            openModalId: this.props.openModalId,
            headerMessage: this.modalHeaderMessage,
            onClose: ()=>this.onClose(),
            children: this.renderModalContent()
        });
    }
    constructor(props){
        super(props);
        this.state = {
            isInProgress: false,
            isFetchDumpInProgress: false,
            isDataCollected: false,
            isDataSaved: false
        };
    }
}
_define_property(GdprExportModal, "propTypes", {
    // Implicit props
    gdprData: PropTypes.object,
    openModalId: PropTypes.string,
    patientProfile: PropTypes.shape({
        accessToken: accessTokenShape,
        storageProvider: PropTypes.string
    }),
    // Implicit actions
    onConnect: PropTypes.func,
    onFetchPhiSet: PropTypes.func,
    onGdprFetchAccountDump: PropTypes.func,
    onFetchCentralStorageDump: PropTypes.func,
    onCancelFetchCentralStorageDump: PropTypes.func,
    onGdprSaveToFile: PropTypes.func,
    onGdprClearData: PropTypes.func,
    onCloseModal: PropTypes.func
});
const mapStateToProps = (state)=>({
        gdprData: selectors.gdprData(state),
        patientProfile: selectors.patientProfile(state),
        isFetchAccountDumpInProgress: selectors.isFetchAccountDumpInProgress(state),
        hasFetchAccountDumpErrors: selectors.hasFetchAccountDumpErrors(state),
        hasFetchPhiSetErrors: CloudDrive.selectors.hasFetchPhiSetErrors(state),
        isFetchDumpInProgress: CloudDrive.selectors.isFetchDumpInProgress(state),
        hasFetchDumpErrors: CloudDrive.selectors.hasFetchDumpErrors(state),
        openModalId: App.selectors.modal(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onConnect: (patientProfile)=>dispatch(actions.connectToPatientStorage(patientProfile)),
        onFetchPhiSet: (patientProfile)=>dispatch(CloudDrive.actions.fetchPhiSet(patientProfile, actions.gdprSetPhiSet)),
        onGdprFetchAccountDump: ()=>dispatch(actions.gdprFetchAccountDump()),
        onFetchCentralStorageDump: (phiSet, patient)=>dispatch(CloudDrive.actions.fetchDump(phiSet, patient, actions.gdprSetCloudDriveDump)),
        onCancelFetchCentralStorageDump: ()=>dispatch(CloudDrive.actions.cancelFetchDump()),
        onGdprSaveToFile: ()=>dispatch(actions.gdprSaveToFile()),
        onGdprClearData: ()=>dispatch(actions.gdprClearData()),
        onCloseModal: ()=>dispatch(App.actions.closeModal())
    });
const ConnectedGdprExportModal = connect(mapStateToProps, mapDispatchToProps)(GdprExportModal);
export default withStyles(styles)(ConnectedGdprExportModal);
